import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
} from "@angular/core";
import {
  provideRouter,
  Router,
  withEnabledBlockingInitialNavigation,
} from "@angular/router";
import { routes } from "./app.routes";
import { OktaAuthModule, OKTA_AUTH } from "@okta/okta-angular";
import { oktaAuth } from "./okta.config";
import { appInitializer } from "./app.init";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { securityInterceptor } from "./api/security.interceptor";
import { provideAnimations } from "@angular/platform-browser/animations";
import { OverlayModule } from "@angular/cdk/overlay";
import { ErrorHandler } from "@angular/core";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { GlobalErrorHandler } from "./core/global-error.handler";
import { LoaderService } from "./core/Loader.services";
import { provideNativeDateAdapter } from "@angular/material/core";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withEnabledBlockingInitialNavigation()),
    importProvidersFrom(OktaAuthModule, OverlayModule, MatSnackBarModule),
    { provide: OKTA_AUTH, useValue: oktaAuth },
    // { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideAppInitializer(() => appInitializer(oktaAuth)()),
    provideHttpClient(withInterceptors([securityInterceptor])),

    provideAnimations(),
    provideNativeDateAdapter(),
  ],
};
